"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var semantic_ui_react_1 = require("semantic-ui-react");
var react_i18next_1 = require("react-i18next");
var react_router_dom_1 = require("react-router-dom");
var FilterDropdown_1 = __importDefault(require("../FilterDropdown"));
var FilterSummary_1 = __importDefault(require("../FilterSummary"));
var PublicCodeInput = function (_a) {
    var _b;
    var _c = _a.filter, label = _c.label, name = _c.name, toggleDropdown = _a.toggleDropdown, appliedFilters = _a.appliedFilters, onSelect = _a.onSelect;
    var t = react_i18next_1.useTranslation('common').t;
    var location = react_router_dom_1.useLocation();
    var _d = react_1.useState((_b = appliedFilters[name]) !== null && _b !== void 0 ? _b : ''), value = _d[0], setValue = _d[1];
    react_1.useEffect(function () {
        if (!location.search.match(/public_code/gm)) {
            setValue('');
        }
    }, [location.search]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(FilterSummary_1.default, { handleClick: toggleDropdown, label: label.toLocaleUpperCase() }),
        react_1.default.createElement(FilterDropdown_1.default, { handleClick: toggleDropdown, label: label.toUpperCase(), filterName: name },
            react_1.default.createElement(semantic_ui_react_1.Input, { name: name, value: value, onChange: function (ev) { return setValue(ev.target.value); }, onBlur: function (ev) {
                    onSelect(ev.target.value);
                } }))));
};
exports.default = PublicCodeInput;
